import _extends from "@babel/runtime-corejs3/helpers/extends";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import React, { useContext } from 'react';
import classNames from 'classnames';
import ConfigContext from '../config-provider/ConfigContext';
import { tuple } from '../_utils/type';
import { getCompProps } from '../_utils';
import devWarning from '../_utils/devwarning';
import { Icon } from '../index';
export var AvatarSizes = tuple('large', 'middle', 'small', 'extra-small');
export var AvatarShapes = tuple('circle', 'square');
var InternalAvatar = function InternalAvatar(props, ref) {
  var _classNames, _context, _classNames2;
  var _useContext = useContext(ConfigContext),
    getPrefixCls = _useContext.getPrefixCls,
    prefixCls = _useContext.prefixCls,
    userDefaultProps = _useContext.compDefaultProps;
  var avatarProps = getCompProps('Avatar', userDefaultProps, props);
  var className = avatarProps.className,
    style = avatarProps.style,
    customPrefixcls = avatarProps.prefixCls,
    shape = avatarProps.shape,
    size = avatarProps.size,
    icon = avatarProps.icon,
    src = avatarProps.src,
    draggable = avatarProps.draggable,
    alt = avatarProps.alt,
    children = avatarProps.children,
    gap = avatarProps.gap,
    disabled = avatarProps.disabled,
    srcSet = avatarProps.srcSet;
  devWarning(AvatarSizes.indexOf(size) === -1 && typeof size !== 'number', 'avatar', "cannot found avatar type '".concat(size, "'"));
  devWarning(AvatarShapes.indexOf(shape) === -1, 'avatar', "cannot found avatar shape '".concat(shape, "'"));
  var _React$useState = React.useState(true),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isImgExist = _React$useState2[0],
    setIsImgExist = _React$useState2[1];
  var _React$useState3 = React.useState(1),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    scale = _React$useState4[0],
    setScale = _React$useState4[1];
  var _React$useState5 = React.useState(false),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    mounted = _React$useState6[0],
    setMounted = _React$useState6[1];
  // ref
  var avatarRef = ref || /*#__PURE__*/React.createRef();
  var avatarChildrenRef = React.useRef();
  // class
  var avatarPrefixCls = getPrefixCls(prefixCls, 'avatar', customPrefixcls);
  var sizeClasses = classNames((_classNames = {}, _defineProperty(_classNames, "".concat(avatarPrefixCls, "-lg"), size === 'large'), _defineProperty(_classNames, "".concat(avatarPrefixCls, "-md"), size === 'middle'), _defineProperty(_classNames, "".concat(avatarPrefixCls, "-sm"), size === 'small'), _defineProperty(_classNames, "".concat(avatarPrefixCls, "-xs"), size === 'extra-small'), _classNames));
  var hasImageElement = /*#__PURE__*/React.isValidElement(src);
  var isShowDefaultIcon = !src && !icon && !children;
  var avatarClasses = classNames(avatarPrefixCls, sizeClasses, (_classNames2 = {}, _defineProperty(_classNames2, _concatInstanceProperty(_context = "".concat(avatarPrefixCls, "-")).call(_context, shape), !!shape), _defineProperty(_classNames2, "".concat(avatarPrefixCls, "-image"), hasImageElement || src && isImgExist), _defineProperty(_classNames2, "".concat(avatarPrefixCls, "-icon"), !!icon || isShowDefaultIcon), _defineProperty(_classNames2, "".concat(avatarPrefixCls, "-disabled"), disabled), _classNames2), className);
  var sizeStyle = typeof size === 'number' ? {
    width: size,
    height: size,
    lineHeight: "".concat(size, "px"),
    fontSize: icon ? size / 2 : 18
  } : {};
  React.useEffect(function () {
    setIsImgExist(true);
    setScale(1);
  }, [src]);
  React.useEffect(function () {
    setScaleParam();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gap]);
  React.useEffect(function () {
    setMounted(true);
  }, []);
  var handleImgLoadError = function handleImgLoadError() {
    var onError = props.onError;
    var errorFlag = onError ? onError() : undefined;
    if (errorFlag !== false) {
      setIsImgExist(false);
    }
  };
  var setScaleParam = function setScaleParam() {
    if (!avatarChildrenRef.current || !avatarRef.current) {
      return;
    }
    var childrenWidth = avatarChildrenRef.current.offsetWidth;
    var nodeWidth = avatarRef.current.offsetWidth;
    if (childrenWidth !== 0 && nodeWidth !== 0) {
      if (gap * 2 < nodeWidth) {
        setScale(nodeWidth - gap * 2 < childrenWidth ? (nodeWidth - gap * 2) / childrenWidth : 1);
      }
    }
  };
  var childrenToRender;
  if (typeof src === 'string' && isImgExist) {
    childrenToRender = /*#__PURE__*/React.createElement("img", {
      src: src,
      srcSet: srcSet,
      draggable: draggable,
      onError: handleImgLoadError,
      alt: alt
    });
  } else if (hasImageElement) {
    childrenToRender = src;
  } else if (icon) {
    childrenToRender = icon;
  } else if (!children) {
    childrenToRender = /*#__PURE__*/React.createElement(Icon, {
      type: "avatar-solid"
    });
  } else if (mounted || scale !== 1) {
    var childrenStyle = {
      transform: "scale(".concat(scale, ") translateX(-50%)")
    };
    var sizeChildrenStyle = typeof size === 'number' ? {
      lineHeight: "".concat(size, "px")
    } : {};
    childrenToRender = /*#__PURE__*/React.createElement("span", {
      className: "".concat(avatarPrefixCls, "-string"),
      ref: function ref(node) {
        avatarChildrenRef.current = node;
      },
      style: _extends(_extends({}, sizeChildrenStyle), childrenStyle)
    }, children);
  } else {
    childrenToRender = /*#__PURE__*/React.createElement("span", {
      className: "".concat(avatarPrefixCls, "-string"),
      style: {
        opacity: 0
      },
      ref: function ref(node) {
        avatarChildrenRef.current = node;
      }
    }, children);
  }
  return /*#__PURE__*/React.createElement("span", {
    ref: avatarRef,
    className: avatarClasses,
    style: _extends(_extends({}, sizeStyle), style)
  }, childrenToRender);
};
var Avatar = /*#__PURE__*/React.forwardRef(InternalAvatar);
Avatar.displayName = 'Avatar';
export default Avatar;